export const selectCertificates = (state) =>
  state.certificate && state.certificate.list ? state.certificate.list : [];
export const selectCertificatesTotal = (state) =>
  state.certificate && state.certificate.total ? state.certificate.total : 0;
